import { Refusals } from "../../../utils/refusalMessageKey";

const toast = (name: string) => `customRegistration.page.toast.${name}`;

const TOO_MANY_ATTEMPTS = { "429": toast("tooManyAttempts") };

// A UMD code names a different refusal on another route (RSUSKO001 is a wrong password on login,
// any refused field on a profile update): each call reads its own table.
export const SIGN_UP_REFUSALS: Refusals = {
  ...TOO_MANY_ATTEMPTS,
  REGISTRATION_ALREADY_COMPLETE: toast("registrationAlreadyComplete"),
  RSUSKO007: toast("checkDetails"),
  RSUSKO029: toast("accountRefused"),
  RSUSKO031: toast("emailDomainNotAllowed"),
  RSUSKO034: toast("registrationsClosed"),
};

export const LOGIN_REFUSALS: Refusals = {
  ...TOO_MANY_ATTEMPTS,
  RSUSKO001: toast("wrongPassword"),
  RSUSKO014: toast("emailNotVerified"),
  RSUSKO017: toast("tooManyAttempts"),
  RSUSKO029: toast("accountRefused"),
  RSUSKO031: toast("emailDomainNotAllowed"),
  RSUSKO034: toast("registrationsClosed"),
};

export const SOCIAL_LOGIN_REFUSALS: Refusals = {
  ...TOO_MANY_ATTEMPTS,
  REGISTRATION_ALREADY_COMPLETE: toast("registrationAlreadyComplete"),
  RSUSKO029: toast("accountRefused"),
  RSUSKO031: toast("emailDomainNotAllowed"),
  RSUSKO034: toast("registrationsClosed"),
};

export const SAVE_REFUSALS: Refusals = {
  ...TOO_MANY_ATTEMPTS,
  REGISTRATION_ALREADY_COMPLETE: toast("registrationAlreadyComplete"),
  RSUSKO007: toast("checkDetails"),
};
